import React from 'react';
import { Button, Modal } from "react-bootstrap";

function RestoreUserModal({ isRestoreModalOpen, selectedUser, closeRestoreModal, confirmRestoreUser, isRestoring }) {
    return (
        <Modal centered show={isRestoreModalOpen} onHide={closeRestoreModal}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Restore</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to restore the user <strong>{selectedUser?.name}</strong>?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeRestoreModal}>
                    Cancel
                </Button>
                <Button variant="success" onClick={confirmRestoreUser}>
                    {isRestoring ?
                        <><span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                        ></span> Restoring...</>
                        :
                        "Restore"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default RestoreUserModal